import React from "react";
import { useParams } from "react-router-dom";
import NovoProdutoFormulario from "./NovoProdutoFormulario";
import ClientHeader from "~components/ClientInfo/ClientHeader";
import useCliente from "~/fetchs/useCliente";
import { useConfigureFooter } from "~hooks/useHelpers";

const NovoProduto = () => {
  useConfigureFooter({ form: true, formId: "formProduct", submitLabel: "Adicionar Produto", notDeveloped: false });

  const { parameter: idCliente } = useParams();
  const { cliente } = useCliente(idCliente);

  return (
    <>
      <ClientHeader dados={cliente} />
      <NovoProdutoFormulario />
    </>
  );
};

export default NovoProduto;
